// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7824d175","867":"5388e4f6"}[chunkId] + ".chunk.js";
};